export const Marquee = ({ dark = false }) => {
  const text = "ONE CHURCH.  ONE FAMILY.  ONE LOVE.  ";
  const repeated = text.repeat(6);
  return (
    <div className={`relative overflow-hidden py-8 ${dark ? "bg-[#0A0A0A]" : "bg-[#E63946]"}`} data-testid="marquee">
      <div className="flex whitespace-nowrap animate-marquee">
        <span className={`font-display font-extrabold tracking-tight text-4xl sm:text-6xl ${dark ? "text-white" : "text-white"}`}>{repeated}</span>
        <span className={`font-display font-extrabold tracking-tight text-4xl sm:text-6xl ${dark ? "text-white" : "text-white"}`} aria-hidden>{repeated}</span>
      </div>
    </div>
  );
};
